import { render, staticRenderFns } from "./ListarClassificacaoOrigem.vue?vue&type=template&id=fa541df4"
import script from "./ListarClassificacaoOrigem.vue?vue&type=script&lang=js"
export * from "./ListarClassificacaoOrigem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports